<template>
  <div class="topMainDiv">
    <span v-if="details.length > 1" class="arrow" @click="prevDetail">‹</span>
    <span>{{ currentDetail }}</span>
    <span v-if="details.length > 1" class="arrow" @click="nextDetail">›</span>
  </div>
</template>


<script>
export default {
  name: "NotificationTopBar",
  inject: ["$contentful"],
  data() {
    return {
      details: [],
      currentDetail: "",
      detailIndex: 0,
      intervalId: null,
    };
  },
  created() {
    this.$contentful
      .getEntries({ content_type: "notificationTopBar" })
      .then((response) => {
        this.details = response.items.map((item) => item.fields.detail);
        if (this.details.length > 0) {
          this.currentDetail = this.details[0];
          this.startRotation();
        }
      });
  },
  methods: {
    startRotation() {
      this.intervalId = setInterval(this.nextDetail, 5000);
    },
    nextDetail() {
      this.detailIndex = (this.detailIndex + 1) % this.details.length;
      this.currentDetail = this.details[this.detailIndex];
    },
    prevDetail() {
      this.detailIndex =
        (this.detailIndex - 1 + this.details.length) % this.details.length;
      this.currentDetail = this.details[this.detailIndex];
    },
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
};
</script>


<style>
.topMainDiv {
  height: 22px;
  font-size: 12px;
  background-color: #635890;
  color: white;
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.arrow {
  cursor: pointer;
  font-weight: bold;
  font-size: 18px;
  user-select: none;
}

</style>
